module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1278"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1278"
    },
    "bundlingPackage": "LoginUI",
    "bundlingPackageVersion": "static-1.16097",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};